import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { AgencyDto } from '@/app/common/general-types/agency.dto';
import { BusinessAccount } from '@/app/common/general-types/business-account.dto';
import { ImageService } from '@/app/services/image/image.service';
import { formatDistanceToNow } from 'date-fns';

@Component({
  selector: 'agency-ins-brands',
  imports: [],
  templateUrl: './brands.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Brands {
  readonly agency = input<AgencyDto | undefined>(undefined);
  readonly imageService = inject(ImageService);
  private readonly router = inject(Router);

  readonly brands = computed(() => this.agency()?.businessAccounts ?? []);

  timeSinceCreated(createdDate: Date | string | undefined): string {
    if (createdDate == null) {
      return '—';
    }
    const d = typeof createdDate === 'string' ? new Date(createdDate) : createdDate;
    if (Number.isNaN(d.getTime())) {
      return '—';
    }
    return formatDistanceToNow(d, { addSuffix: true });
  }

  onBrandSelect(brand: BusinessAccount): void {
    void this.router.navigate(['/insights/brand', brand.id]);
  }
}
